import { render, staticRenderFns } from "./dovizinput.vue?vue&type=template&id=3e21008e&scoped=true&"
import script from "./dovizinput.vue?vue&type=script&lang=js&"
export * from "./dovizinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21008e",
  null
  
)

export default component.exports